
// to add excel bulkupload Lead

export const ADD_FILEUPLOAD_START = 'ADD_FILEUPLOAD_START';
export const ADD_FILEUPLOAD_SUCCESS = 'ADD_FILEUPLOAD_SUCCESS';
export const ADD_FILEUPLOAD_FAILURE = 'ADD_FILEUPLOAD_FAILURE';
export const ADD_FILEUPLOAD_RESET = 'ADD_FILEUPLOAD_RESET';


// to add excel bulkupload Customer

export const ADD_CUSTFILEUPLOAD_START = 'ADD_CUSTFILEUPLOAD_START';
export const ADD_CUSTFILEUPLOAD_SUCCESS = 'ADD_CUSTFILEUPLOAD_SUCCESS';
export const ADD_CUSTFILEUPLOAD_FAILURE = 'ADD_CUSTFILEUPLOAD_FAILURE';
export const ADD_CUSTFILEUPLOAD_RESET = 'ADD_CUSTFILEUPLOAD_RESET';



// to add excel bulkupload in policy

export const ADD_POLICYFILEUPLOAD_START = 'ADD_POLICYFILEUPLOAD_START';
export const ADD_POLICYFILEUPLOAD_SUCCESS = 'ADD_POLICYFILEUPLOAD_SUCCESS';
export const ADD_POLICYFILEUPLOAD_FAILURE = 'ADD_POLICYFILEUPLOAD_FAILURE';
export const ADD_POLICYFILEUPLOAD_RESET = 'ADD_POLICYFILEUPLOAD_RESET';


//Get bulk uploads leads

export const GET_LEADS_BULKUPLOADS = "GET_LEADS_BULKUPLOADS"
export const GET_LEADS_BULKUPLOADS_SUCCESS = "GET_LEADS_BULKUPLOADS_SUCCESS"
export const GET_LEADS_BULKUPLOADS_FAILED = "GET_LEADS_BULKUPLOADS_FAILED"


export const REVERT_BULK_UPLOAD = "REVERT_BULK_UPLOAD"
export const REVERT_BULK_UPLOAD_SUCCESS = "REVERT_BULK_UPLOAD_SUCCESS"
export const REVERT_BULK_UPLOAD_FAILED = "REVERT_BULK_UPLOAD_FAILED"


export const GET_CUST_BULKUPLOAD = "GET_CUST_BULKUPLOAD"
export const GET_CUST_BULKUPLOAD_SUCCESS = "GET_CUST_BULKUPLOAD_SUCCESS"
export const GET_CUST_BULKUPLOAD_FAILED = "GET_CUST_BULKUPLOAD_FAILED"



export const GET_POLICY_BULKUPLOAD = "GET_POLICY_BULKUPLOAD"
export const GET_POLICY_BULKUPLOAD_SUCCESS = "GET_POLICY_BULKUPLOAD_SUCCESS"
export const GET_POLICY_BULKUPLOAD_FAILED = "GET_POLICY_BULKUPLOAD_FAILED"

export const GET_LIFE_BULKPOLICIES = "GET_LIFE_BULKPOLICIES"
export const GET_LIFE_BULKPOLICIES_SUCCESS = "GET_LIFE_BULKPOLICIES_SUCCESS"
export const GET_LIFE_BULKPOLICIES_FAILED = "GET_LIFE_BULKPOLICIES_FAILED"

// add Mutual fund bulk upload

export const ADD_MUTUALFUNDFILEUPLOAD_START = 'ADD_MUTUALFUNDFILEUPLOAD_START';
export const ADD_MUTUALFUNDFILEUPLOAD_SUCCESS = 'ADD_MUTUALFUNDFILEUPLOAD_SUCCESS';
export const ADD_MUTUALFUNDFILEUPLOAD_FAILURE = 'ADD_MUTUALFUNDFILEUPLOAD_FAILURE';
export const ADD_MUTUALFUNDFILEUPLOAD_RESET = 'ADD_MUTUALFUNDFILEUPLOAD_RESET';

//revert mutual fund bulk upload

export const REVERT_MUTUALFUND_BULK_UPLOAD = "REVERT_MUTUALFUND_BULK_UPLOAD"
export const REVERT_MUTUALFUND_BULK_UPLOAD_SUCCESS = "REVERT_MUTUALFUND_BULK_UPLOAD_SUCCESS"
export const REVERT_MUTUALFUND_BULK_UPLOAD_FAILED = "REVERT_MUTUALFUND_BULK_UPLOAD_FAILED"

//View Mutual Fund bulk upload

export const GET_MUTUALFUND_BULKUPLOADS = "GET_MUTUALFUND_BULKUPLOADS"
export const GET_MUTUALFUND_BULKUPLOADS_SUCCESS = "GET_MUTUALFUND_BULKUPLOADS_SUCCESS"
export const GET_MUTUALFUND_BULKUPLOADS_FAILED = "GET_MUTUALFUND_BULKUPLOADS_FAILED"